<template>
  <v-card :elevation="currentPlan && currentPlan.id === plan.id ? 3 : 0" >
    <v-card-title class="pa-0 text-center justify-center display-1 font-weight-light">
      <v-flex :class="plan.class" class="pa-3" v-html="plan.name"></v-flex>
    </v-card-title>
    <v-card-text class="px-0">
      <v-list>
        <v-list-item>
          <v-list-item-icon class="list-item-icon">
            <v-icon v-if="plan.maxDays">
              mdi-calendar
            </v-icon>
            <v-icon v-else>
              mdi-account-group
            </v-icon>
          </v-list-item-icon>
          <v-list-item-content v-if="plan.id !== -1">
            <v-list-item-title :class="{'pt-2': currentPlan && currentPlan.id === plan.id}" v-if="plan.maxDays">
              {{plan.maxDays}} days to test it
            </v-list-item-title>
            <v-list-item-title :class="{'pt-2': currentPlan && currentPlan.id === plan.id}" v-else>
              Up to {{plan.maxProfiles}} profiles
            </v-list-item-title>
            <v-list-item-subtitle>
              <v-list v-if="currentPlan && currentPlan.id === plan.id" style="max-width:200px">
                <v-list-item class="px-0">
                  <v-list-item-icon class="list-item-icon">
                    <v-icon>mdi-account</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-subtitle>
                      {{currentPlan.staffCount}} staff profiles
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item class="px-0">
                  <v-list-item-icon class="list-item-icon">
                    <v-icon>
                      mdi-account-tie-voice
                    </v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-subtitle>
                      {{currentPlan.scoutingCount}} scouting profiles
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>

            </v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-content v-else>
            <v-list-item-title>
              Need more capacity?
            </v-list-item-title>
          </v-list-item-content>

        </v-list-item>

        <template v-if="plan.pricePerMonth !== undefined">
          <v-list-item>
            <v-list-item-icon class="list-item-icon">
              <v-icon>
                mdi-coin
              </v-icon>
            </v-list-item-icon>
            <v-list-item-title>
              {{plan.pricePerMonth | currency }}{{plan.currency}} / month
            </v-list-item-title>
          </v-list-item>
          <v-list-item class="">
            <v-list-item-icon class="list-item-icon">
              <v-icon>
                mdi-coin
              </v-icon>
            </v-list-item-icon>
            <v-list-item-title>
              {{plan.pricePerYear | currency }}{{plan.currency}} / year
            </v-list-item-title>
          </v-list-item>
        </template>
        <template v-else>
          <v-list-item class="text-center align-self-center justify-center">
            <v-btn @click="contactUs" :color="plan.btnClass" dark>Contact us</v-btn>
          </v-list-item>
        </template>

      </v-list>
    </v-card-text>

    <v-card-actions>
      <iceverg-plan-form :plan="plan" :currentPlan="currentPlan"></iceverg-plan-form>
    </v-card-actions>
  </v-card>
</template>

<script>
  import IcevergPlanForm from "../Forms/icevergPlanForm";

  export default {
    name: "icevergPlan",
    components: {IcevergPlanForm},
    props: ['plan', 'currentPlan'],
    methods: {
      contactUs() {
        window.location.href = 'mailto:info@iceverg.com?subject=Request higher plan&body=Hi! I\'d like to request a plan for more than 1000 profiles\n'
      }
    }
  }
</script>

<style scoped>
  .list-item-icon{
    margin-right:15px !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/Widgets/icevergPlan.vue